;(function () {
	var MOBILE_BREAKPOINT = 990

	var initSlider = function (timeline) {
		var body = timeline.querySelector('.timeline-rows__body')
		var slides = timeline.querySelector('.timeline-rows__slides')
		var items = timeline.querySelectorAll('.timeline-rows__item')
		var pagination = timeline.querySelector('.timeline-rows__pagination')

		if (!body || !slides || body.classList.contains('swiper')) return

		body.classList.add('swiper')
		slides.classList.add('swiper-wrapper')
		items.forEach(function (el) {
			el.classList.add('swiper-slide')
		})

		body._timelineSwiper = new Swiper(body, {
			loop: false,
			speed: 600,
			slidesPerView: 1.03,
			spaceBetween: 8,
			pagination: pagination
				? { el: pagination, clickable: true }
				: false,
			breakpoints: {
				750: {
					slidesPerView: 1.2,
					spaceBetween: 24,
				},
			},
		})
	}

	var destroySlider = function (timeline) {
		var body = timeline.querySelector('.timeline-rows__body')
		var slides = timeline.querySelector('.timeline-rows__slides')
		var items = timeline.querySelectorAll('.timeline-rows__item')

		if (!body || !body.classList.contains('swiper')) return

		if (body._timelineSwiper) {
			body._timelineSwiper.destroy(true, true)
			body._timelineSwiper = null
		}

		body.classList.remove('swiper')
		if (slides) slides.classList.remove('swiper-wrapper')
		items.forEach(function (el) {
			el.classList.remove('swiper-slide')
			el.removeAttribute('style')
		})
	}

	var initSection = function (timeline) {
		if (!timeline) return

		var ro = new ResizeObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.contentRect.width < MOBILE_BREAKPOINT) {
					initSlider(timeline)
				} else {
					destroySlider(timeline)
				}
			})
		})

		ro.observe(timeline)
	}

	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.timeline-rows').forEach(initSection)
	})

	document.addEventListener('shopify:section:load', function (e) {
		e.target.querySelectorAll('.timeline-rows').forEach(initSection)
	})
})()
